import Persistable from "../../storage/persistable";

export default class Event extends Persistable {
    getHomeTeam() {
        return this.teams.homeTeam;
    }

    getAwayTeam() {
        return this.teams.awayTeam;
    }
}
